module.exports = __webpack_public_path__ + "static/media/snake.08389ebc.png";